'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoDiff = function GoDiff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 10h-5v5h-5v5h5v5h5v-5h5v-5h-5v-5z m-10 25h15v-5h-15v5z m17.5-35h-20v2.5h18.8l8.7 8.8v23.7h2.5v-25l-10-10z m-25 5v35h30v-27.5l-7.5-7.5h-22.5z m27.5 32.5h-25v-30h18.8l6.2 6.3v23.7z' })
        )
    );
};

exports.default = GoDiff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/diff.js
// module id = 1699
// module chunks = 0